{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Разширението за Chrome не е инсталирано.",
      "CTA": "Инсталиране на разширението"
    },
    "STATUS": {
      "OFFLINE": "Телефонът е офлайн",
      "IN_OTHER_TAB": "Телефонът е свързан в друг раздел",
      "CONNECTING": "Свързване...",
      "DISCONNECTING": "Прекъсване...",
      "ONLINE": "Телефонът е онлайн",
      "DIALING": "Набиране",
      "TRANSFERRING": "Прехвърляне...",
      "CONSULTING": "Разговор с оператора",
      "CALLER_ON_HOLD": "Обаждащият се изчаква",
      "BUSY": "Зает",
      "DND": "DND",
      "UNAVAILABLE": "Недостъпен",
      "REJECTED": "Обаждането е отхвърлено",
      "CALL_FAILED": "Обаждането е неуспешно"
    },
    "QUEUES": {
      "MORE": "Още опашки"
    },
    "TABS": {
      "PHONE": "Телефон",
      "SMS": "SMS",
      "HISTORY": "История"
    },
    "HISTORY": {
      "OPEN": "Отворен",
      "RECENT": "Скорошни",
      "MISSED": "Пропуснато",
      "LOADING": "Зареждане на обажданията...",
      "EMPTY": "Няма обаждания тук",
      "ERROR": "Обажданията не можаха да се заредят",
      "CALL": "Обади се отново",
      "CALL_STATUS": {
        "BUTTON": "Задай статус на обаждането",
        "TITLE": "Статус на обаждането",
        "SEARCH_PLACEHOLDER": "Търсене на статуси...",
        "LOADING": "Зареждане на статусите...",
        "NO_OPTIONS": "Няма конфигурирани статуси за обаждания",
        "NO_MATCH": "Няма съвпадащ статус",
        "OPTIONS_ERROR": "Статусите не можаха да се заредят",
        "RETRY": "Опитайте отново",
        "CONFIRM_QUESTION": "Задаване на „{status}“ и разрешаване на разговора?",
        "CONFIRM": "Потвърди",
        "BACK": "Назад",
        "CANCEL": "Отказ",
        "SAVING": "Запазване...",
        "SAVE_ERROR": "Статусът не можа да бъде запазен",
        "RESOLVE_ERROR": "Статусът е запазен, но разговорът не можа да бъде разрешен"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Телефонен номер, напр. +421903000000",
      "BODY_PLACEHOLDER": "Напишете съобщението...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Изпрати SMS",
      "SENDING": "Изпращане...",
      "SENT": "SMS е изпратен",
      "LOADING": "Зареждане на SMS входящи кутии...",
      "NO_INBOX": "Този акаунт няма SMS входяща кутия, затова SMS не може да бъде изпратен.",
      "INVALID_NUMBER": "Въведете номера в международен формат, включително водещия +.",
      "ERROR": "SMS-ът не можа да бъде изпратен. Моля, опитайте отново."
    },
    "ACTIONS": {
      "CONNECT": "Свържи",
      "GO_TO_TAB": "Към този раздел",
      "DISCONNECT": "Прекъсни",
      "ANSWER": "Приеми",
      "HANGUP": "Затвори",
      "HOLD": "Задръж",
      "MUTE": "Изключи микрофона",
      "SILENCE": "Изключи звука",
      "TRANSFER": "Прехвърли",
      "COMPLETE_TRANSFER": "Завърши прехвърлянето",
      "RETURN_TO_CALLER": "Обратно към обаждащия се",
      "CANCEL_TRANSFER": "Отказ от прехвърлянето",
      "DIALPAD": "Покажи клавиатурата",
      "OPEN_CONVERSATION": "Отвори разговора"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Входящо обаждане",
      "INCOMING_CALL_FROM": "Входящо обаждане от {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Входящо обаждане от {number}",
      "ANSWER": "Приеми",
      "DECLINE": "Откажи"
    },
    "TRANSFER": {
      "TITLE": "Прехвърляне на обаждане",
      "PLACEHOLDER": "Въведете номер на получател за прехвърляне...",
      "SEARCH_PLACEHOLDER": "Търсене на оператори...",
      "TARGET_PLACEHOLDER": "Избран получател за прехвърляне",
      "CONFIRM": "Прехвърли",
      "MODE_DIRECT": "Прехвърли веднага",
      "MODE_CONSULT": "Първо се обадете на оператора",
      "CANCEL": "Отказ"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Сигурни ли сте, че искате да отидете в почивка за всички опашки?",
      "CONFIRM_READY": "Сигурни ли сте, че искате да се върнете в готов статус за всички опашки?",
      "CONFIRM_BREAK_QUEUE": "Сигурни ли сте, че искате да излезете от опашката {queue}?",
      "CONFIRM_READY_QUEUE": "Сигурни ли сте, че искате да влезете в опашката {queue}?",
      "LOGIN_TO_QUEUE": "Влез",
      "LOGOUT_FROM_QUEUE": "Излез",
      "LOGIN_TO_ALL_QUEUES": "Влез във всички опашки",
      "LOGOUT_FROM_ALL_QUEUES": "Излез от всички опашки",
      "OPTION_LOGOUT": "Излизане",
      "OPTION_BREAK": "Почивка",
      "OPTION_LUNCH": "Обяд",
      "OPTION_AWAY": "Отсъстващ",
      "OPTION_DO_NOT_DISTURB": "Не безпокойте",
      "OPTION_BUSINESS_TRIP": "Командировка",
      "CONFIRM": "Потвърди",
      "CANCEL": "Отказ"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Няма връзка с телефонната система",
      "MESSAGE": "Изглежда, че вашата интернет връзка не работи. Моля, проверете я и опитайте отново.",
      "CREDENTIALS_TITLE": "Телефонната система отхвърли вашите данни за вход",
      "CREDENTIALS_MESSAGE": "Телефонната система отказа потребителското име или паролата, запазени във вашия профил. Проверете ги в Настройки на профила или се свържете с администратора си.",
      "CONFIGURATION_TITLE": "Настройките на телефона не са валидни",
      "CONFIGURATION_MESSAGE": "Потребителското име за SIP или адресът на сървъра не са във валиден формат, затова телефонът не може да се свърже. Коригирайте го в Настройки на профила.",
      "NETWORK_SHORT": "Неуспешна връзка",
      "CREDENTIALS_SHORT": "Отхвърлени данни",
      "CONFIGURATION_SHORT": "Невалидни настройки",
      "RETRY": "Опитайте отново",
      "DISMISS": "Отказ"
    },
    "CONNECTION_QUALITY": "Качество на връзката",
    "CONNECTION_QUALITY_EXCELLENT": "Отлично",
    "CONNECTION_QUALITY_GOOD": "Добро",
    "CONNECTION_QUALITY_FAIR": "Приемливо",
    "CONNECTION_QUALITY_POOR": "Лошо",
    "CONNECTION_QUALITY_DISCONNECTED": "Прекъснато"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Набиране на {number}… Можете да затворите този раздел.",
    "NO_NUMBER": "Не е предоставен номер. Използвайте ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Въведете телефонен номер...",
    "ACTIONS": {
      "DIAL": "Набери номер",
      "DIAL_FROM": "Изберете номера, от който звъните"
    },
    "DIAL_FROM": {
      "TITLE": "Обаждане от номера на входяща кутия"
    },
    "VALIDATION": {
      "REQUIRED": "Телефонният номер е задължителен",
      "INVALID_FORMAT": "Невалиден формат на телефонен номер"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Настройки на аудио и тестване",
    "SELECT_DEVICE": "Изберете устройство...",
    "SYSTEM_DEFAULT": "Системно по подразбиране",
    "SAVED": "Запазено",
    "DISCONNECTED_SUFFIX": "не е свързано",
    "DEVICE_DISCONNECTED": "Избраното устройство не е свързано. Разговорите използват системното устройство по подразбиране, докато не се върне.",
    "MICROPHONE": {
      "TITLE": "Микрофон",
      "START_TEST": "Тествай микрофона",
      "STOP_TEST": "Спри тестването",
      "LEVEL": "Ниво:",
      "VERDICT": {
        "LISTENING": "Кажете нещо в микрофона…",
        "SILENT": "Не ви чуват. Проверете дали микрофонът е включен и дали е избран правилният.",
        "LOW": "Чуват ви само тихо. Изберете друг микрофон или настройте входната сила на звука в системните настройки.",
        "GOOD": "Добър звук — чуват ви добре."
      }
    },
    "SPEAKER": {
      "TITLE": "Говорител",
      "TEST": "Тествай говорителя",
      "TESTING": "Тестване...",
      "VOLUME": "Сила:",
      "USING_DEFAULT": "Избраният изход не е достъпен — възпроизведено през системното устройство по подразбиране."
    },
    "DONE": "Готово",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Грешка при достъп до микрофона. Моля, проверете разрешенията.",
      "MICROPHONE_PERMISSION_DENIED": "Достъпът до микрофона е блокиран. Разрешете го в настройките на сайта в браузъра, за да използвате телефона.",
      "MICROPHONE_SILENT": "Вашият микрофон не улавя никакъв звук. Проверете настройките за звук.",
      "EXTENSION_REQUIRED": "Разширението за телефон не е открито. Инсталирайте или активирайте го, за да използвате микрофона.",
      "SPEAKER_TEST": "Грешка при тестване на говорителя."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Офлайн",
    "ONLINE": "Онлайн",
    "BUSY": "Зает"
  },
  "QUEUE_STATUS": {
    "READY": "Готов",
    "NOT_READY": "Не приема обаждания",
    "WRAP_UP": "Приключване",
    "BREAK": "Почивка",
    "LUNCH": "Обяд",
    "AWAY": "Отсъстващ",
    "DO_NOT_DISTURB": "Не безпокойте",
    "BUSINESS_TRIP": "Командировка",
    "OTHER_CALL": "Друго обаждане",
    "QUEUE_CALL": "Обаждане от опашка",
    "OFFLINE": "Офлайн",
    "ONLINE": "Онлайн",
    "NO_ACCESS": "Няма телефон",
    "PARTIALLY_READY": "Частично готов",
    "MIXED": "Смесен",
    "CHAT_ONLINE": "Онлайн (чат)",
    "CHAT_BUSY": "Заето (чат)",
    "CHAT_OFFLINE": "Офлайн (чат)"
  }
}
